import { ROUTES_PATH } from 'constants/routesPath'

export const userPathDetect = () => {
    const isLoginPage = window.location.pathname === ROUTES_PATH.SIGN_IN
    const isLoginWithLinkPage = window.location.pathname === ROUTES_PATH.SIGN_IN_WITH_LINK

    return {
        isLoginPage,
        isLoginWithLinkPage,
    }
}
